package com.tovtalk.data.mapper

import com.tovtalk.data.remote.dto.CommentDto
import com.tovtalk.data.remote.dto.ReplyCommentDto
import com.tovtalk.domain.entity.Comment
import com.tovtalk.domain.entity.ReplyComment

/**
 * Comment Mapper - DTO to Entity
 */
object CommentMapper {
    
    fun mapToEntity(dto: CommentDto): Comment {
        return Comment(
            id = dto.id,
            postId = dto.postId,
            userId = dto.userId,
            text = dto.text,
            gifUrl = dto.gifUrl,
            likes = dto.likes,
            replyCount = dto.replyCount,
            isLiked = dto.isLiked,
            isPinned = dto.isPinned == 1,
            user = dto.user?.let { UserMapper.mapToEntity(it) },
            replies = emptyList(),  // Replies loaded separately
            createdAt = parseInstant(dto.createdAt),
            updatedAt = parseInstant(dto.updatedAt ?: dto.createdAt)
        )
    }
    
    fun mapReplyToEntity(dto: ReplyCommentDto): ReplyComment {
        return ReplyComment(
            id = dto.id,
            commentId = dto.commentId,
            userId = dto.userId,
            text = dto.text,
            gifUrl = dto.gifUrl,
            likes = dto.likes,
            isLiked = dto.isLiked == 1,
            user = dto.user?.let { UserMapper.mapToEntity(it) },
            createdAt = parseInstant(dto.createdAt),
            updatedAt = parseInstant(dto.updatedAt)
        )
    }
}
